export const theme = {
  colors: {
    primary: "#bb1ccc", 
    secondary: "#f8116a",
    ternary:"#00dcfa",
    main: "#006eb3",
    dark: "#5756a2",
    lightBlue: "#f4f6fd",
    gradient:"linear-gradient(90deg, #9440E8 0%, #F8116A 51.04%, #FF5A22 100%)",
    success:"#4BA703",
    fail:"red",
    white:"#fff",
    marsOrange:"#ff7832",
    disabledColor:"#D2D2D2",
    yellow: "#eccb64",
  },

  fonts: {
    roboto: "Roboto, sans-serif",
  },
  fontSizes: {
    small: "1em",
    medium: "2em",
    large: "3em",
  },
};
